import { ServicePageTemplate } from "@/components/services/ServicePageTemplate";
import { servicePages } from "@/data/servicePages";

const data = servicePages.find((s) => s.slug === "annual-tax-returns")!;
const AnnualTaxReturns = () => <ServicePageTemplate data={data} />;
export default AnnualTaxReturns;
